module.exports = __webpack_public_path__ + "static/media/bacon.bc9f92d3.svg";